import type { FunctionComponent } from 'react';
import classNames from 'classnames';
import { PerkListProps } from './interface';
import * as styles from './PerkList.module.css';

const SEE_TERMS_LABEL = 'See Terms here.';

const PerkList: FunctionComponent<PerkListProps> = ({ list, variation = '', style = {} }) => (
  <div
    data-testid="perk-list-container"
    className={classNames(styles.perkListContainer, styles[variation])}
    style={style}
  >
    <div className={styles.wrapper}>
      <ul className={styles.perkList}>
        {list?.map((perk) => (
          <li key={perk.id}>
            <div className={styles.iconContainer}>
              <img src={perk.image} alt={perk.label} />
            </div>
            <div className={styles.perkDescription}>
              <div className={styles.perkTitle}>
                <strong>{perk.label}</strong>
              </div>
              <p>
                {perk.content}
                {perk.termsLink && (
                  <span className={styles.termsLink}>
                    {' '}
                    <a href={perk.termsLink} target="_blank" rel="noreferrer">
                      {SEE_TERMS_LABEL}
                    </a>
                  </span>
                )}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default PerkList;
